import React, { useState, useCallback, useEffect } from "react";
import { producaov2 as api } from "../../../../services/apis";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Footer from "../../../../components/Footer";
import { Container, Box, Header, FormBlock } from "./styles";
import { isAuthAdmin } from "../../../../services/auth";

import swal from "sweetalert";
import {
  Form,
  Input,
  FormField,
  FormGroup,
  Button,
  Select,
} from "semantic-ui-react";


const RelatorioPersonalizacao = () => {
  document.title = "Painel Administrativo | Grupo Voitto";

  const [dataInicio, setDataInicio] = useState(new Date());
  const [dataFinal, setDataFinal] = useState(new Date());

  const [loadingNovo, setLoadingNovo] = useState(false);
  const [loadingAntigo, setLoadingAntigo] = useState(false);

  const [relatorioNovo, setRelatorioNovo] = useState(false);
  const [relatorioAntigo, setRelatorioAntigo] = useState(false);

  useEffect(() => {
    loadAuth();
  }, []);
  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const handleGenerateReport = useCallback((value) => {

    if (value == 'new') {
      setRelatorioNovo(false);
      setLoadingNovo(true);
    } else {
      setRelatorioAntigo(false);
      setLoadingAntigo(true);
    }
    api
      .post(`admin/relatorio-personalizacao/${value}`, {
        data_inicio: dataInicio,
        data_final: dataFinal,
      })
      .then((res) => {

        if (value == 'new') {
          setRelatorioNovo(...[res.data.response]);
          setLoadingNovo(false);
        } else {
          setRelatorioAntigo(...[res.data.response]);
          setLoadingAntigo(false);
        }

        let array = {
          local: "Relatorio/personalizacao",
          texto: `Gerou o relatorio entre ${dataInicio} e ${dataFinal}}`,
        };
        api.post("system_logs", { acao: JSON.stringify(array) });
        swal("Confirmado!", "Relatório gerado com sucesso", "success");
        window.open(res.data.response, "blank");
      })
      .catch((error) => {

        if (value == 'new') {
          setLoadingNovo(false);
        } else {
          setLoadingAntigo(false);
        }

        if (error.response) {
          swal(
            `Algo deu errado`,
            `Se persistir, contate nosso suporte`,
            "error"
          );
        }
      });
  }, [dataInicio, dataFinal, swal]);

  return (
    <>
      <AdminMenu />
      <Container>
        <Header>Relatório Personalização</Header>
        <Box>
          <Form>
            <FormBlock>
              <p>Selecionar período</p>
              <FormField>
                A partir de
                <Input
                  onChange={(e) => setDataInicio(e.target.value)}
                  type="date"
                />
                até
                <Input
                  onChange={(e) => setDataFinal(e.target.value)}
                  type="date"
                />
              </FormField>
            </FormBlock>

            <FormGroup>
              <Button
                color="green"
                onClick={() => handleGenerateReport('new')}
                loading={loadingNovo}
              >
                Gerar Relatório novo
              </Button>
              {relatorioNovo && (
                <Button
                  style={{ minWidth: "80px" }}
                  onClick={() => window.open(relatorioNovo, "_blank")}
                  color="green"
                >
                  Baixar Relatório novo
                </Button>
              )}
            </FormGroup>

            <FormGroup>
              <Button
                color="orange"
                onClick={() => handleGenerateReport('old')}
                loading={loadingAntigo}
              >
                Gerar Relatório antigo
              </Button>
              {relatorioAntigo && (
                <Button
                  style={{ minWidth: "80px" }}
                  onClick={() => window.open(relatorioAntigo, "_blank")}
                  color="orange"
                >
                  Baixar Relatório antigo
                </Button>
              )}
            </FormGroup>
          </Form>
        </Box>
      </Container>
      <Footer />
    </>
  );
};

export default RelatorioPersonalizacao;
